import saveWasteEntry from "./saveWasteEntry";
import wasteEntry from "./wasteEntry";

const reducers = {
  saveWasteEntry,
  wasteEntry,
};

export default reducers;
